import { UITypes } from "types"

import MessageReportStatusCount from "components/table/columnComponents/MessageReportStatusCount"

export const messageHistoryTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Title",
    type: "sort-search",
    name: "title",
  },
  {
    title: "Message",
    type: "sort-search",
    cellComponent: "markdown",
    name: "body",
  },
  {
    title: "Date",
    type: "sort-date-range",
    name: "date",
  },
  {
    title: "Delivered",
    type: "sort",
    size: "small",
    name: "delivered",
    cellComponent: MessageReportStatusCount,
  },
  {
    title: "Pending",
    type: "sort",
    size: "small",
    name: "pending",
    cellComponent: MessageReportStatusCount,
  },
  {
    title: "Failed",
    type: "sort",
    size: "small",
    name: "failed",
    cellComponent: MessageReportStatusCount,
  },
]
